import { ApiWrapper } from "../utils/api-wrapper";

export class ExtendedApiWrapper extends ApiWrapper {
  async getSuggestionPrompts(limit, programName) {
    return await this.get(
      `/custom-prompt-messages?num_prompts=${limit}&program_name=${programName}`
    );
  }
  async sendMessageWithSSE(
    userInput,
    onMessage,
    onError,
    onComplete,
    signal,
    programName,
    userType = "user" 
  ) {
    const body = {
      message: userInput,
      user_type: userType,
      program_name: programName,
    };
    return this.streamWithAuth(
      "/stream_chat",
      body,
      onMessage,
      onError,
      (messageId) => onComplete?.(messageId),
      signal
    );
  }

  async getChatHistory(
    limit = 100,
    offset = 0,
    programName
  ) {
    return this.get(
      `/get_chat_history?limit=${limit}&offset=${offset}&program_name=${programName}`
    );
  }
  async sendFeedback(message_id, feedback, programName) {
    const requestBody = {
      message_id,
      feedback,
      program_name: programName,
    };

    return this.post("/feedback", requestBody);
  }
  async getAcknowledgementStatus() {
    return await this.get("/acknowledgment-status");
  }

  async sendAcknowledgement(approved) {
    const requestBody = {
      approved,
    };

    return this.post("/acknowledge", requestBody);
  }
}

let extendedApiWrapper = null;

export function initExtendedApiWrapper(apiUrl) {
  extendedApiWrapper = new ExtendedApiWrapper(apiUrl);
}

export function getExtendedApiWrapper() {
  if (!extendedApiWrapper) {
    throw new Error("ExtendedApiWrapper is not initialized. Please call initExtendedApiWrapper(apiUrl) first.");
  }
  return extendedApiWrapper;
}
